// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_workbench_casestatus_processing11 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`processing`)
};

const en_us2_workbench_casestatus_processing11 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`processing`)
};

const de_de2_workbench_casestatus_processing11 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prozessiere`)
};

const en_workbench_casestatus_processing11 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`processing`)
};

const de_workbench_casestatus_processing11 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prozessiere`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const workbench_casestatus_processing11 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.workbench_casestatus_processing11(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("workbench_casestatus_processing11", locale)
	if (locale === "en-GB") return en_gb2_workbench_casestatus_processing11(inputs)
	if (locale === "en-US") return en_us2_workbench_casestatus_processing11(inputs)
	if (locale === "de-DE") return de_de2_workbench_casestatus_processing11(inputs)
	if (locale === "en") return en_workbench_casestatus_processing11(inputs)
	return de_workbench_casestatus_processing11(inputs)
};
export { workbench_casestatus_processing11 as "workbench.caseStatus.PROCESSING" }